import React, { useEffect,useState } from 'react'
import './Product.css' 
import Star from './Star';
import { Use_reduce_state } from './Store';

function Products() {
    const {product:{searchKey}, dis} = Use_reduce_state();
    const [products, setProducts] = useState([])

    const allP = async() =>{
        const res = await fetch('https://dummyjson.com/products');
        const data = await res.json();
        setProducts(data.products);
    }
    console.log(products);
    useEffect(()=>{
        allP();
    },[])
  return (
    <div className='container'>
        <div className="row">
        {
            products.filter(p => p.title.toLowerCase().includes(searchKey) || p.brand.toLowerCase().includes(searchKey))
            .map((item, i)=>{
                return(
                    <div className='col-3 py-2' key={i} >
                        <div className="main_box" >
                            <img src={item.thumbnail} alt="imageOfProduct" className='img_box' />
                            <div className="text_box">
                                <h5>{item.title}</h5>
                                <h4>{new Intl.NumberFormat('hi-IN', { style: 'currency', currency: 'INR' }).format(item.price*10)}</h4>
                                <Star rating={item.rating} />
                                <p>{item.description.slice(0,40)}...</p>
                                <button type="button" className="btn btn-outline-primary btn-sm"
                                onClick={()=>{
                                    dis({
                                        type:"ADD_TO_CART",
                                        payload: item
                                    })
                                } }
                                >Add To Cart</button>
                            </div>

                        </div>
                    </div>
                )
            })
        }
        </div>
       
    </div>
  )
}

export default Products